export default __webpack_public_path__ + "static/media/batteraside5.b8b780dc.png";